//AgelessBookShelf.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
// import Tooltip from '../../components/utils/Tooltip';
import AgelessBookShelfListComponent from './AgelessBookShelfListComponent';
import '../learning/styles/BookShelf.css';

const AgelessBookShelf = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();

    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [bookId, setBookId] = useState(null);

    const [isMyBooksHovered, setIsMyBooksHovered] = useState(false);
    const [isFlyingOnTheWallHovered, setIsFlyingOnTheWallHovered] = useState(false);
    const [isDcrHovered, setIsDcrHovered] = useState(false);

    const handleMyBooksMouseEnter = () => {
        setIsMyBooksHovered(true);
    };

    const handleMyBooksMouseLeave = () => {
        setIsMyBooksHovered(false);
    };

    const handleFlyingOnTheWallMouseEnter = () => {
        setIsFlyingOnTheWallHovered(true);
    };

    const handleFlyingOnTheWallMouseLeave = () => {
        setIsFlyingOnTheWallHovered(false);
    };

    const handleDcrMouseEnter = () => {
        setIsDcrHovered(true);
    };

    const handleDcrMouseLeave = () => {
        setIsDcrHovered(false);
    };

    const handleFlyingOnTheWallClick = () => {
        navigate('/flyersonthewall', { state: { bookId: 'All', bookTitle: 'All', ownerId: userId, ownerName: userName, fromPage: "bookShelfTop" } });
    };

    const handleDcrClick = () => {
        navigate("/dcrlist", { state: { bookId: 'All', bookTitle: 'All', ownerId: userId, ownerName: userName, fromPage: "bookShelfTop" } });
    };

    return (
        <div className="overflow-x-hidden">
        <MainLayout>
            <div className="min-h-screen py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-12">
                <h3 className='text-2xl font-bold text-white text-center'>My BookShelf</h3>
                <div className="flex flex-row justify-center">
                    <button
                        id='mybooks'
                        className='mr-4'
                        style={{
                            backgroundColor: isMyBooksHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        onMouseEnter={handleMyBooksMouseEnter}
                        onMouseLeave={handleMyBooksMouseLeave}
                    >
                        My Books
                    </button>
                    <button
                        id='mybooks'
                        className='mr-4'
                        style={{
                            backgroundColor: isFlyingOnTheWallHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        onMouseEnter={handleFlyingOnTheWallMouseEnter}
                        onMouseLeave={handleFlyingOnTheWallMouseLeave}
                        onClick={() => handleFlyingOnTheWallClick()}
                    >
                        Flying On The Wall
                    </button>
                    <button
                        id='coreaders'
                        style={{
                            backgroundColor: isDcrHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        disabled={true}
                        onMouseEnter={handleDcrMouseEnter}
                        onMouseLeave={handleDcrMouseLeave}
                        onClick={() => handleDcrClick()}
                    >
                        Co-Readers
                    </button>
                </div>
                <div className="full-width-container">
                    <AgelessBookShelfListComponent />
                </div>
            </div>
        </MainLayout>
        </div>
    );
};

export default AgelessBookShelf;
